import { Directive, HostBinding, Input } from "@angular/core";
import { Pattern, Role } from "@hex/angular/decorators";

@Directive({
    selector: "[hexTextColor]",
})
export class CustomHexTextColorDirective {
    @Input() @Role("color", { input: true }) hexTextColor = "";
    @Role("color") @Pattern("danger") @HostBinding("class.c-hext-text--danger-color") isDangerColor = false;
    @Role("color") @Pattern("warning") @HostBinding("class.c-hext-text--warning-color") isWarningColor = false;
    @Role("color") @Pattern("info") @HostBinding("class.c-hext-text--info-color") isInfoColor = false;
}
